// extracted by mini-css-extract-plugin
module.exports = {"main-content-text":"content-text_main-content-text__1uIBA","learn-more":"content-text_learn-more__1XVG9"};